import { login, mobile_login,logintow } from "@/api/auth/login"
import { register, registerMobile } from "@/api/auth/register"
import { getToken, setToken, removeToken, getAutoLoginRange, setAutoLoginRange } from "@/utils/auth"
import { memberDetail } from "@/api/member/member"
// import { memberInfo } from "@/api/member/index"

const state = {
    token: getToken(),
    autoLoginRange: getAutoLoginRange(),
    member: "",
    firstQualification: null,
    withoutLoginPriceTip:"登录可见",
    storeWithoutAuthority:"无权查看",
}

const mutations = {
    SET_TOKEN: (state, token) => {
        const tokenChanged = state.token !== token
        state.token = token
        if (tokenChanged) {
            state.member = ""
            state.firstQualification = null
        }
    },
    SET_AUTOLOGIN_FLAG: (state, autologinRange) => {
        state.autoLoginRange = autologinRange
    },
    SET_MEMBER: (state, member) => {
        state.member = member
    },
    SET_FIRST_QUALIFICATION: (state, qualification) => {
        state.firstQualification = qualification
    }
}

const actions = {
    login({ commit }, userInfo) {
        const { username, password, security_code, captcha_id, captcha_code, autoLoginRange, random, member_id, type } = userInfo

        // 帮下单自动登录：只需传递 type、random、member_id
        const loginParams = type === 'help_order'
            ? { type, random, member_id }
            : { username, password, security_code, captcha_id, captcha_code, autoLoginRange }

        return new Promise((resolve, reject) => {
            return login(loginParams)
                .then(res => {
                    const { code, message, data } = res
                    if (code == 0) {
                        commit("SET_TOKEN", data.token)

                        // 勾选七天自动登录时为 7，否则为 0（会话 Cookie，关闭浏览器即失效）
                        const range = autoLoginRange || 0
                        commit("SET_AUTOLOGIN_FLAG", range)
                        setAutoLoginRange(range)
                        setToken(data.token, range)

                        resolve(res)
                    }else{
                        reject(res)
                    }
                })
                .catch(_err => {
                    reject(_err)
                })
        })
    },
    login_warehouse({ commit }, userInfo){
        let postObj = {
            username: userInfo.nickname,
            password: 'jxkj123',
            is_warehouse:'1'
        };
        return new Promise((resolve, reject) => {
	        return login(postObj).then(res => {
                const { code, message, data } = res
                if (code == 0) {
                    commit("SET_TOKEN", data.token);
                    setToken(data.token, userInfo.autoLoginRange || getAutoLoginRange());
                    resolve(res);
                }
                reject();
            }).catch(_err => {
                reject(_err);
            })
	    })
    },
	logintow({ commit }, userInfo) {
	    const { member_id, change } = userInfo
	    return new Promise((resolve, reject) => {
	        return login({ member_id, change })
	            .then(res => {
	                const { code, message, data } = res
	               if (code == 0) {
	                    commit("SET_TOKEN", data.token)

	                    // 切换账号沿用当前的自动登录设置，避免降级为会话 Cookie
	                    const range = userInfo.autoLoginRange || getAutoLoginRange()
	                    commit("SET_AUTOLOGIN_FLAG", range)
	                    setToken(data.token, range)

	                    resolve(res)
	                }

	                reject()
	            })
	            .catch(_err => {
	                reject(_err)
	            })
	    })
	},

    mobile_login({ commit }, userInfo) {
        const { mobile, key, code } = userInfo

        return new Promise((resolve, reject) => {
            return mobile_login({ mobile, key, code })
                .then(res => {
                    const { code, message, data } = res

                    if (code == 0) {
                        commit("SET_TOKEN", data.token)

                        const range = userInfo.autoLoginRange || getAutoLoginRange()
                        commit("SET_AUTOLOGIN_FLAG", range)
                        setToken(data.token, range)

                        resolve(res)
                    }

                    reject()
                })
                .catch(_err => {
                    reject(_err)
                })
        })
    },

    remove_token({ commit }) {
        commit("SET_TOKEN", "")
        removeToken()
    },
	// 账号密码
    register_token({ commit }, userInfo) {
		const { username, password, captcha_id, captcha_code , member_label , realname , nickname , province_id , city_id , district_id , full_address , member_label_name, member_id,qualifications_images,mobile,parent_id,inputfenxiao_name,invitation_code,address,...others} = userInfo

		return new Promise((resolve, reject) => {
		    return register({ username, password, captcha_id, captcha_code ,member_label , realname , nickname , province_id , city_id , district_id , full_address , member_label_name, member_id,qualifications_images,mobile,parent_id,inputfenxiao_name,invitation_code,address,...others})
		        .then(res => {
		            const { code, message, data } = res
		            if (code == 0) {
		                commit("SET_TOKEN", data.token)

		                setToken(data.token)

		                resolve(res)

		            }else{
                        reject(res)
                    }
		        })
		        .catch(_err => {
		            reject(_err)
		        })
		})
        commit("SET_TOKEN", "")
    },
	// 手机号
	registerMobile_token({ commit }, userInfo) {
		const { mobile, key, code, captcha_id, captcha_code } = userInfo

		return new Promise((resolve, reject) => {
		    return registerMobile({ mobile, key, code, captcha_id, captcha_code })
		        .then(res => {
		            const { code, message, data } = res

		            if (code == 0) {
		                commit("SET_TOKEN", data.token)

		                setToken(data.token)

		                resolve(res)
		            }

		            reject()
		        })
		        .catch(_err => {
		            reject(_err)
		        })
		})
	    commit("SET_TOKEN", "")
	},

    auto_login_range({ commit }, autologinRange) {
        commit("SET_AUTOLOGIN_FLAG", autologinRange)
    },

    logout({ commit }) {
        commit("SET_TOKEN", "")
        commit("SET_MEMBER", "")
        commit("SET_FIRST_QUALIFICATION", null)
        commit("SET_AUTOLOGIN_FLAG", 0)
        removeToken()
        // 主动退出视为放弃自动登录；remove_token 是 token 失效时的被动清理，不动该偏好
        setAutoLoginRange(0)
       window.location.reload()
    },

    /**
     * params refresh:1 表示强制请求客户信息
     */
    member_detail({ commit, state }, params) {
        if (!state.member || (params && params.refresh)) {
            return new Promise((resolve, reject) => {
                return memberDetail({ token: getToken() })
                    .then(res => {
                        const { data } = res
                        const qualification = res && res.qualifications_url
                        const isValidQualification = qualification
                            && !Array.isArray(qualification)
                            && typeof qualification === "object"
                            && typeof qualification.url === "string"
                            && qualification.url.trim()
                        commit("SET_MEMBER", data)
                        commit("SET_FIRST_QUALIFICATION", isValidQualification ? qualification : null)
                        return resolve(res)
                    })
                    .catch(err => {
                        return reject(err)
                    })
            })
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
